import {Injectable, QueryList, ElementRef} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class JsonataExpressionsResizeService {
    private resizeCleanupFunctions: (() => void)[] = [];
    private previousWindowWidth: number = window.innerWidth;

    initializeResizeHandles(resizeHandles: QueryList<ElementRef>): void {
        if (!resizeHandles || resizeHandles.length === 0) {
            return;
        }

        resizeHandles.forEach((handleRef) => {
            const handle = handleRef.nativeElement as HTMLElement;
            const leftPanel = handle.previousElementSibling as HTMLElement;
            const rightPanel = handle.nextElementSibling as HTMLElement;

            if (!leftPanel || !rightPanel) {
                return;
            }

            let isResizing = false;
            let startX = 0;
            let startLeftWidth = 0;
            let startRightWidth = 0;

            const onMouseDown = (e: MouseEvent) => {
                isResizing = true;
                startX = e.clientX;
                startLeftWidth = leftPanel.offsetWidth;
                startRightWidth = rightPanel.offsetWidth;
                document.body.style.cursor = 'col-resize';
                document.body.style.userSelect = 'none';
                e.preventDefault();
            };

            const onMouseMove = (e: MouseEvent) => {
                if (!isResizing) return;

                const container = leftPanel.parentElement;
                if (!container) return;

                const containerWidth = container.offsetWidth;
                const delta = e.clientX - startX;
                const newLeftWidth = startLeftWidth + delta;
                const newRightWidth = startRightWidth - delta;

                const minWidth = 200;
                if (newLeftWidth > minWidth && newRightWidth > minWidth) {
                    const leftPercent = (newLeftWidth / containerWidth) * 100;
                    const rightPercent = (newRightWidth / containerWidth) * 100;

                    leftPanel.style.flex = `0 0 ${leftPercent}%`;
                    rightPanel.style.flex = `0 0 ${rightPercent}%`;
                }
            };

            const onMouseUp = () => {
                if (isResizing) {
                    isResizing = false;
                    document.body.style.cursor = '';
                    document.body.style.userSelect = '';
                }
            };

            handle.addEventListener('mousedown', onMouseDown);
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);

            this.resizeCleanupFunctions.push(() => {
                handle.removeEventListener('mousedown', onMouseDown);
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            });
        });
    }

    initializeWindowResizeListener(editorPanels: QueryList<ElementRef>): void {
        const handleWindowResize = () => {
            const currentWidth = window.innerWidth;
            const breakpoint = 1024;

            const wasDesktop = this.previousWindowWidth > breakpoint;
            const isDesktop = currentWidth > breakpoint;

            if (wasDesktop !== isDesktop) {
                if (editorPanels) {
                    editorPanels.forEach((panelRef) => {
                        const panel = panelRef.nativeElement as HTMLElement;
                        panel.style.flex = '';
                    });
                }
            }

            this.previousWindowWidth = currentWidth;
        };

        window.addEventListener('resize', handleWindowResize);

        this.resizeCleanupFunctions.push(() => {
            window.removeEventListener('resize', handleWindowResize);
        });
    }

    cleanup(): void {
        this.resizeCleanupFunctions.forEach(cleanup => cleanup());
        this.resizeCleanupFunctions = [];
    }
}
